// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-page-2-js": () => import("./../../../src/pages/page-2.js" /* webpackChunkName: "component---src-pages-page-2-js" */),
  "component---src-templates-clinic-community-resources-js": () => import("./../../../src/templates/clinic-community-resources.js" /* webpackChunkName: "component---src-templates-clinic-community-resources-js" */),
  "component---src-templates-clinic-js": () => import("./../../../src/templates/clinic.js" /* webpackChunkName: "component---src-templates-clinic-js" */),
  "component---src-templates-page-js": () => import("./../../../src/templates/page.js" /* webpackChunkName: "component---src-templates-page-js" */)
}

